export default "__VITE_ASSET__DTGm$YSu__"